import { render } from "./TurnosView.vue?vue&type=template&id=fea87e68&scoped=true"
import script from "./TurnosView.vue?vue&type=script&lang=js"
export * from "./TurnosView.vue?vue&type=script&lang=js"

import "./TurnosView.vue?vue&type=style&index=0&id=fea87e68&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea87e68"]])

export default __exports__